import React from 'react';
import type { ReactElement } from 'react';
import clsx from 'clsx';

type CancelButtonProps = {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
};

// Provide fixed button text here to encourage 'Cancel' to be consistently used.
export function UnstyledCancelButton({
  className,
  onClick,
  disabled
}: CancelButtonProps): ReactElement {
  return (
    <button type="button" className={className} onClick={onClick} disabled={disabled}>
      Cancel
    </button>
  );
}

/**
 * A cancel button with default styling for consistency.
 */
export default function CancelButton({
  className,
  onClick,
  disabled
}: CancelButtonProps): ReactElement {
  return (
    <UnstyledCancelButton
      className={clsx('btn btn-outline-primary', className)}
      onClick={onClick}
      disabled={disabled}
    />
  );
}
